export const GET_ARTEFACTS_ERROR = "redux_store:artefacts.error.get";
export const DELETE_ARTEFACT_ERROR = "redux_store:artefacts.error.delete";
export const UPDATE_ARTEFACT_ERROR = "redux_store:artefacts.error.patch";
export const ADD_ARTEFACT_ERROR = "redux_store:artefacts.error.post";

export const GET_ARTEFACT_TYPES_ERROR = "redux_store:artefacts.error.get_types";


// WEBPACK FOOTER //
// ./src/errors/artefacts.js